import React, { useState } from 'react'
import Alert from '~/Common-Objects/UI/Alert'
import Column from '~/Common-Objects/Grids/Column/Column'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import Toggle from '~/Common-Objects/UI/Forms/Toggle/Toggle'
import i18n from '~/i18n'
import { Tooltip } from 'react-tooltip'
import moment from 'moment'
import { useSelector } from 'react-redux'
import StartDate from '../../shared/startDate'

const timeblocks = []
const timeblocksEnd = []
const time = moment('00:00', 'HH:mm')
for (var i = 0; i < 48; i++) {
    timeblocks.push({ label: time.format('HH:mm'), value: time.format(), disabled: i < 9 * 2 || i >= 20 * 2 })
    timeblocksEnd.push({ label: time.format('HH:mm'), value: time.format(), disabled: i <= 9 * 2 || i > 20 * 2 })
    time.add(30, 'minutes')
}

export default function SmsSendStartTime({ campaign, updateCampaign = () => { } }) {
    const user = useSelector(state => state.user)

    const updateOptions = (ev) => {
        var options = campaign.options || {}
        var value = ev.currentTarget.value;
        if (ev.target.name == "recurringType") {
            if (value == "none") {
                options.recurringValue = 0
            }
            if (value == "daily") {
                options.recurringValue = 1
            }
            if (value == "weekly") {
                options.recurringValue = "monday"
            }
            if (value == "monthly") {
                options.recurringValue = "1"
            }
        }
        options[ev.currentTarget.name] = value
        options.timezone = user.userData.timeZone

        updateCampaign()
    }

    const changeStartDate = (v) => {
        campaign.startDate = v;
        updateCampaign()
    }

    let betweenStart = timeblocks.find(b => !b.disabled).value
    let betweenEnd = [...timeblocksEnd].reverse().find(b => !b.disabled).value
    if (campaign.options?.betweenStart) {
        betweenStart = timeblocks.find(b => !b.disabled && moment(campaign.options.betweenStart).format("HH:mm") === b.label)?.value
    }
    if (campaign.options?.betweenEnd) {
        betweenEnd = [...timeblocksEnd].reverse().find(b => !b.disabled && moment(campaign.options.betweenEnd).format("HH:mm") === b.label)?.value
    }

    return (
        <Paper className="mar-b20">
            <Row>
                <Column xs={12} sm={6} margin={0}>
                    <h4 className="mar-b25" >{i18n.t('campaigns:standard.step3.scheduleTitle')}</h4>
                </Column>

                <Column xs={12} className="mar-b20">
                    <StartDate startDate={campaign.startDate} setStartDate={changeStartDate} />
                </Column>


                <Column xs={12} sm={6} md={6} margin={0}>
                    <div>
                        <Toggle checked={true} disabled={true} name="checkedSendBetween"
                            after={<span>{i18n.t('campaigns:standard.step3.limitSendingTimes')} <div style={{ color: '#999', fontSize: 12 }}>Only send SMS between specific hours of the day</div>  </span>}
                        />
                    </div>
                    <div className="form-group mar-t15 mar-b0">
                        <div className="quickFlex">
                            <Select label='Start Time' outerstyle={{ flexGrow: 1, marginRight: "20px" }} data={timeblocks} value={betweenStart} name="betweenStart" onChange={updateOptions}></Select>
                            <Select label='End Time' outerstyle={{ flexGrow: 1 }} data={timeblocksEnd} value={betweenEnd} name="betweenEnd" onChange={updateOptions}></Select>
                        </div>
                    </div>
                </Column>
                <Column xs={12} margin={0} className="mar-t10">
                    <Alert
                        type="info"
                        header="SMS Messages can only be sent between 9am and 8pm"
                        content="To comply with UK marketing regulations, message cannot be sent outside this period"
                    />
                </Column>

            </Row>
        </Paper>
    )
}